<div class="h-screen flex flex-col overflow-hidden bg-pageBg">
    <app-header class="shrink-0"></app-header>
    <div class="flex-1 flex flex-col min-h-0 overflow-hidden pt-4 pb-[44px] text-gray-800 antialiased">
        <div class="w-full mx-auto px-4 xl:px-8 flex flex-col flex-1 h-full overflow-hidden">

            <!-- Header Section -->
            <div
                class="relative bg-white border border-gray-200 shadow-sm rounded-2xl overflow-hidden shrink-0 mb-4 mt-2">
                <div
                    class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brandPurple via-brandPurpleDark to-brandAccent">
                </div>

                <div class="px-8 py-6 flex flex-col lg:flex-row lg:items-center justify-between gap-6"
                    style="background-color: aliceblue">
                    <div>
                        <h1 class="text-2xl font-black text-gray-900 tracking-tight flex items-center gap-2">
                            User Roles
                            <span class="px-2 py-0.5 bg-brandPurple/10 text-brandPurple text-xs font-bold rounded-full"
                                *ngIf="accessRolesList.length">{{ getTotalFilteredCount() }} Total</span>
                        </h1>
                        <p class="text-gray-500 text-sm mt-1">Manage roles, permissions, access modules &amp; workbench
                            access.</p>
                    </div>

                    <div class="flex flex-wrap items-center gap-4">
                        <!-- Integrated Search & Filters -->
                        <div class="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-1.5 focus-within:ring-2 focus-within:ring-brandAccent/20 focus-within:border-brandAccent transition-all shadow-sm"
                            *ngIf="accessRolesList.length > 0">
                            <svg class="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                            </svg>
                            <input type="text"
                                class="bg-transparent border-none focus:ring-0 outline-none sm w-48 lg:w-64"
                                placeholder="Quick Search..." [(ngModel)]="search" (ngModelChange)="currentPage = 1"
                                [disabled]="isRefreshTable">
                        </div>

                        <div class="h-8 w-px bg-gray-200 mx-1 hidden lg:block" *ngIf="accessRolesList.length > 0"></div>

                        <div class="flex items-center gap-2" *ngIf="accessRolesList.length > 0">
                            <button
                                class="p-2.5 text-gray-500 hover:text-brandPurple hover:bg-brandPurple/10 rounded-xl transition-all"
                                (click)="getAccessRoles(true, false)" [disabled]="isRefreshTable" title="Refresh Table">
                                <svg class="w-5 h-5" [ngClass]="{'animate-spin': isRefreshTable}" fill="none"
                                    stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                                    </path>
                                </svg>
                            </button>
                            <button
                                class="p-2.5 text-gray-500 hover:text-brandPurple hover:bg-brandPurple/10 rounded-xl transition-all"
                                (click)="showHideColumnSettings()" [disabled]="isRefreshTable" title="Column Settings">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2m0 0V7a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2h-2a2 2 0 01-2-2V7">
                                    </path>
                                </svg>
                            </button>
                        </div>

                        <button *ngIf="!storeManager"
                            class="bg-brandAccent hover:bg-brandPurple text-white px-6 py-2.5 rounded-xl text-sm font-bold shadow-lg shadow-brandAccent/20 transition-all hover:shadow-brandAccent/40 hover:-translate-y-0.5 active:scale-95"
                            (click)="openForm()">
                            Create Role
                        </button>
                    </div>
                </div>
            </div>

            <!-- Success / Error Messages -->
            <div *ngIf="message" class="mb-4 bg-green-50 border-l-4 border-green-500 p-4 rounded-md shadow-sm">
                <p class="text-green-700 text-sm font-bold">{{ message }}</p>
            </div>
            <div *ngIf="errorMessage" class="mb-4 bg-red-50 border-l-4 border-red-500 p-4 rounded-md shadow-sm">
                <p class="text-red-700 text-sm font-bold">{{ errorMessage }}</p>
            </div>

            <!-- Refresh Bar -->
            <div *ngIf="isRefreshTable"
                class="mb-4 bg-blue-50 border-l-4 border-blue-400 p-3 rounded-md shadow-sm flex justify-between items-center">
                <span class="text-blue-700 text-sm font-medium">{{ refreshTableText }}</span>
                <span class="text-blue-600 text-sm font-bold">{{ totalRecords }} records</span>
            </div>

            <!-- Loading State (Outside table container) -->
            <div *ngIf="!isLoaded"
                class="bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col flex-1 overflow-hidden min-h-0 mb-4">
                <div class="text-center py-20 bg-gray-50/50">
                    <div class="flex flex-col items-center gap-4">
                        <div
                            class="w-8 h-8 border-4 border-brandAccent/20 border-t-brandAccent rounded-full animate-spin">
                        </div>
                        <span class="text-gray-400 font-medium">Loading role data...</span>
                    </div>
                </div>
            </div>
            <!-- Main Roles Table -->
            <div class="bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col flex-1 overflow-hidden min-h-0 mb-4"
                *ngIf="isLoaded && accessRolesList.length > 0">

                <!-- BODY SECTION -->
                <div class="overflow-auto flex-1 relative custom-scrollbar">

                    <table class="min-w-full text-xs lg:text-sm text-left table-fixed">

                        <colgroup>
                            <col *ngIf="columnVisibility['role']" class="w-[20%]">
                            <col *ngIf="columnVisibility['code']" class="w-[18%]">
                            <col *ngIf="columnVisibility['details']" class="w-[42%]">
                            <col *ngIf="columnVisibility['clone'] && !storeManager" class="w-[10%]">
                            <col *ngIf="columnVisibility['view']" class="w-[10%]">
                        </colgroup>

                        <thead class="bg-gray-50/50 text-gray-400">
                            <tr>

                                <!-- ROLE -->
                                <th *ngIf="columnVisibility['role']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('role')">

                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Role</span>
                                        <span class="sm:hidden text-[9px]">R</span>

                                        <svg *ngIf="sortType === 'role'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">

                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd">
                                            </path>

                                        </svg>
                                    </div>

                                </th>

                                <!-- CODE -->
                                <th *ngIf="columnVisibility['code']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('code')">

                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Code</span>
                                        <span class="sm:hidden text-[9px]">C</span>

                                        <svg *ngIf="sortType === 'code'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">

                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd">
                                            </path>

                                        </svg>
                                    </div>

                                </th>

                                <!-- DETAILS -->
                                <th *ngIf="columnVisibility['details']"
                                    class="sticky top-0 z-10 px-3 lg:px-6 py-3 lg:py-4 font-bold uppercase tracking-wider cursor-pointer text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue" (click)="setSort('details')">

                                    <div class="flex items-center gap-1">
                                        <span class="hidden sm:inline">Details</span>
                                        <span class="sm:hidden text-[9px]">D</span>

                                        <svg *ngIf="sortType === 'details'"
                                            class="w-3 h-3 lg:w-3.5 lg:h-3.5 transition-transform"
                                            [ngClass]="{'rotate-180': sortReverse}" fill="currentColor"
                                            viewBox="0 0 20 20">

                                            <path fill-rule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clip-rule="evenodd">
                                            </path>

                                        </svg>
                                    </div>

                                </th>

                                <!-- CLONE -->
                                <th *ngIf="columnVisibility['clone'] && !storeManager"
                                    class="sticky top-0 z-10 px-2 lg:px-3 py-3 lg:py-4 font-bold uppercase tracking-wider text-center text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue">

                                    <span class="hidden sm:inline">Clone</span>
                                    <span class="sm:hidden text-[9px]">CL</span>

                                </th>

                                <!-- VIEW -->
                                <th *ngIf="columnVisibility['view']"
                                    class="sticky top-0 z-10 px-2 lg:px-3 py-3 lg:py-4 font-bold uppercase tracking-wider text-center text-gray-900 text-[10px] lg:text-sm shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue">

                                    <span class="hidden sm:inline">View</span>
                                    <span class="sm:hidden text-[9px]">V</span>

                                </th>

                            </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-100/60">

                            <!-- EMPTY -->
                            <tr *ngIf="isLoaded && accessRolesList.length === 0">
                                <td colspan="5" class="text-center py-12 lg:py-20 text-gray-400 font-medium">
                                    No roles found
                                </td>
                            </tr>

                            <!-- DATA -->
                            <tr *ngFor="let access_role of getPaginatedRoles()"
                                class="group cursor-pointer transition-all duration-200" [ngClass]="{
                        'bg-brandAccent/[0.03] border-l-4 border-l-brandAccent shadow-[inset_0_0_0_1px_rgba(var(--brandAccent-rgb),0.05)]':
                            access_role.id === selectedRow,

                        'hover:bg-gray-50/80 border-l-4 border-l-transparent':
                            access_role.id !== selectedRow
                    }" (click)="setClickedRow(access_role.id); dblClickAction(access_role)">

                                <!-- ROLE -->
                                <td *ngIf="columnVisibility['role']" class="px-3 lg:px-6 py-3 lg:py-4">

                                    <span
                                        class="font-bold text-gray-600 group-hover:text-brandPurple transition-colors break-words whitespace-normal text-xs lg:text-sm"
                                        [style.max-width]="'150px'" [style.display]="'inline-block'"
                                        [style.word-break]="'break-word'">

                                        {{ access_role.role }}

                                    </span>

                                </td>

                                <!-- CODE -->
                                <td *ngIf="columnVisibility['code']"
                                    class="px-3 lg:px-6 py-3 lg:py-4 font-medium text-gray-600 group-hover:text-brandPurple text-xs lg:text-sm transition-colors">

                                    <span class="break-words whitespace-normal" [style.max-width]="'150px'"
                                        [style.display]="'inline-block'" [style.word-break]="'break-word'">

                                        {{ access_role.code }}

                                    </span>

                                </td>

                                <!-- DETAILS -->
                                <td *ngIf="columnVisibility['details']"
                                    class="px-3 lg:px-6 py-3 lg:py-4 text-gray-600 group-hover:text-brandPurple text-xs lg:text-sm transition-colors"
                                    [title]="access_role.details">

                                    <span class="break-words whitespace-normal" [style.display]="'inline-block'"
                                        [style.word-break]="'break-word'">

                                        {{ access_role.details }}

                                    </span>

                                </td>

                                <!-- CLONE -->
                                <td *ngIf="columnVisibility['clone'] && !storeManager"
                                    class="px-2 lg:px-3 py-3 lg:py-4 text-center">

                                    <div class="flex items-center justify-center">

                                        <button
                                            class="w-8 lg:w-10 h-7 lg:h-8 flex items-center justify-center rounded-lg border border-purple-200 text-purple-600 bg-purple-50 hover:bg-purple-100 transition-all"
                                            title="Clone" (click)="$event.stopPropagation(); openClone(access_role)">

                                            <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                                viewBox="0 0 24 24">

                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z">
                                                </path>

                                            </svg>

                                        </button>

                                    </div>

                                </td>

                                <!-- VIEW -->
                                <td *ngIf="columnVisibility['view']" class="px-2 lg:px-3 py-3 lg:py-4">

                                    <div class="flex items-center justify-center">

                                        <button
                                            class="w-8 lg:w-10 h-7 lg:h-8 flex items-center justify-center rounded-lg border border-purple-200 text-purple-600 bg-purple-50 hover:bg-purple-100 transition-all"
                                            (click)="$event.stopPropagation(); dblClickAction(access_role)">

                                            <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                                viewBox="0 0 24 24">

                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M9 5l7 7-7 7">
                                                </path>

                                            </svg>

                                        </button>

                                    </div>

                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div>

                <!-- PAGINATION -->
                <div class="px-4 lg:px-8 py-3 lg:py-5 border-t border-gray-100 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 lg:gap-0 bg-gray-50/50 shrink-0"
                    *ngIf="isLoaded && accessRolesList.length > 0">

                    <div class="text-[10px] lg:text-xs font-bold text-gray-400 uppercase tracking-widest">

                        Displaying

                        <span class="text-gray-900">
                            {{ (currentPage - 1) * pageSize + 1 }}-{{ getVisibleCount() }}
                        </span>

                        of {{ getTotalFilteredCount() }}

                    </div>

                    <div class="flex flex-col sm:flex-row items-center gap-3 lg:gap-6">

                        <!-- PAGE SIZE -->
                        <div class="flex items-center gap-1 p-1 bg-white border border-gray-200 rounded-xl">

                            <button *ngFor="let size of [10, 25, 50, 100]"
                                class="px-1.5 lg:px-2 py-1 text-[9px] lg:text-[10px] font-black rounded-lg transition-all"
                                [ngClass]="pageSize === size ? 'bg-brandAccent text-white shadow-sm' : 'text-gray-400 hover:bg-gray-50'"
                                (click)="pageSize = size; currentPage = 1">

                                {{size}}

                            </button>

                        </div>

                        <!-- PAGINATION -->
                        <div class="flex items-center gap-1 lg:gap-2">

                            <button
                                class="p-1.5 lg:p-2 border border-gray-200 rounded-xl bg-white text-gray-500 hover:text-brandPurple disabled:opacity-30 transition-all"
                                [disabled]="currentPage === 1" (click)="pageChange(currentPage - 1)">

                                <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">

                                    <path d="M15 19l-7-7 7-7" stroke-width="2" />

                                </svg>

                            </button>

                            <div class="flex items-center gap-1 px-2">

                                <span class="text-[9px] lg:text-xs font-bold text-gray-900">
                                    {{ currentPage }}
                                </span>

                                <span class="text-[9px] lg:text-xs text-gray-300">/</span>

                                <span class="text-[9px] lg:text-xs font-bold text-gray-400">
                                    {{ getTotalPages() }}
                                </span>

                            </div>

                            <button
                                class="p-1.5 lg:p-2 border border-gray-200 rounded-xl bg-white text-gray-500 hover:text-brandPurple disabled:opacity-30 transition-all"
                                [disabled]="currentPage * pageSize >= getTotalFilteredCount()"
                                (click)="pageChange(currentPage + 1)">

                                <svg class="w-3 lg:w-4 h-3 lg:h-4" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24">

                                    <path d="M9 5l7 7-7 7" stroke-width="2" />

                                </svg>

                            </button>

                        </div>

                    </div>

                </div>

            </div>

            <!-- ================================================================ -->
            <!-- ROLE DETAILS PANEL (Sliding Drawer) -->
            <!-- ================================================================ -->
            <div class="fixed inset-0 z-[110] overflow-hidden transition-all duration-500 ease-in-out pointer-events-none"
                [ngClass]="isShowRoleDetails ? 'visible' : 'invisible'" *ngIf="role_information && role_information.id">
                <!-- Backdrop -->
                <div *ngIf="isShowRoleDetails"
                    class="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-500 ease-in-out pointer-events-auto"
                    [ngClass]="isShowRoleDetails ? 'opacity-100' : 'opacity-0'" (click)="closeRoleDetails()">
                </div>

                <!-- Drawer -->
                <div class="absolute inset-y-0 right-0 w-full max-w-4xl bg-white shadow-2xl transition-transform duration-500 ease-in-out pointer-events-auto flex flex-col"
                    [ngClass]="isShowRoleDetails ? 'translate-x-0' : 'translate-x-full'">

                    <!-- Drawer Header -->
                    <div
                        class="px-8 py-6 border-b border-gray-100 flex items-center justify-between bg-white sticky top-0 z-10">
                        <div class="flex flex-col">
                            <h2 class="text-2xl font-black text-gray-900 tracking-tight">{{ role_information.role }}
                            </h2>
                            <div class="flex items-center gap-2 mt-1">
                                <span
                                    class="px-2 py-0.5 rounded text-[10px] font-black uppercase tracking-widest bg-brandAccent/10 text-brandAccent">
                                    Code: {{ role_information.code }}
                                </span>
                                <span class="text-gray-300 text-xs">&bull;</span>
                                <span class="text-gray-500 text-xs font-bold uppercase tracking-tighter">{{
                                    userCountForRole
                                    }} Users</span>
                            </div>
                        </div>
                        <div class="flex items-center gap-3">
                            <div
                                class="flex flex-wrap gap-4 items-center justify-between p-4 bg-white border border-brandAccent/20 rounded-2xl shadow-sm shadow-brandAccent/5">
                                <button *ngIf="!storeManager"
                                    class="px-6 py-2 bg-gray-50 hover:bg-brandAccent/10 text-gray-700 hover:text-brandAccent text-xs font-bold rounded-xl transition-all border border-brandAccent/10 active:scale-95"
                                    (click)="$event.stopPropagation(); openUpdateProfilePanel()">
                                    Update
                                </button>
                                <button *ngIf="!storeManager"
                                    class="px-6 py-2 bg-red-50 hover:bg-red-100 text-red-600 text-xs font-bold rounded-xl transition-all border border-red-100 active:scale-95 flex items-center gap-2 shadow-sm"
                                    (click)="showDeletePopup(role_information)"><svg class="w-4 h-4" fill="none"
                                        stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                        </path>
                                    </svg>
                                    Delete
                                </button>
                            </div>
                            <div class="w-px h-6 bg-gray-200 mx-1"></div>
                            <button
                                class="w-10 h-10 flex items-center justify-center rounded-xl text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all"
                                (click)="closeRoleDetails()">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Drawer Content -->
                    <div class="flex-1 overflow-y-auto p-8 bg-gray-50/30">
                        <div class="mb-4 text-sm text-gray-500 max-w-2xl">{{ role_information.details }}</div>

                        <!-- Inline messages -->
                        <div *ngIf="message"
                            class="mb-6 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl text-sm font-bold shadow-sm">
                            {{ message }}</div>
                        <div *ngIf="errorMessage"
                            class="mb-6 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-xl text-sm font-bold shadow-sm">
                            {{ errorMessage }}</div>

                        <!-- Tabs -->
                        <div class="flex items-center p-1 bg-gray-100 rounded-2xl mb-8 overflow-x-auto shrink-0">
                            <button
                                class="flex-1 min-w-[120px] px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-xl transition-all"
                                [ngClass]="isSummary ? 'bg-white text-brandPurple shadow-sm' : 'text-gray-400 hover:text-gray-600'"
                                (click)="loadUsersByRoleId()">Summary</button>
                            <button
                                class="flex-1 min-w-[120px] px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-xl transition-all"
                                [ngClass]="isShowPermission ? 'bg-white text-brandPurple shadow-sm' : 'text-gray-400 hover:text-gray-600'"
                                (click)="loadRolePermissionsByRoleId(true); loadCartByRoleId()">Permissions</button>
                            <button
                                class="flex-1 min-w-[120px] px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-xl transition-all"
                                [ngClass]="isModules ? 'bg-white text-brandPurple shadow-sm' : 'text-gray-400 hover:text-gray-600'"
                                (click)="getRoleModules()">Modules</button>
                            <button
                                class="flex-1 min-w-[120px] px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-xl transition-all"
                                [ngClass]="isWorkbench ? 'bg-white text-brandPurple shadow-sm' : 'text-gray-400 hover:text-gray-600'"
                                (click)="getAccessWorkbench()">Workbench</button>
                            <button
                                class="flex-1 min-w-[120px] px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-xl transition-all"
                                [ngClass]="isFeatureModule ? 'bg-white text-brandPurple shadow-sm' : 'text-gray-400 hover:text-gray-600'"
                                (click)="getFeatureAccessModules()">Feature</button>
                        </div>

                        <!-- ======== SUMMARY TAB ======== -->
                        <div *ngIf="isSummary">
                            <!-- Existing Users / Available Users -->
                            <fieldset [disabled]="!isUsersLoaded">
                                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                    <!-- Existing Users -->
                                    <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                                        <h3 class="text-sm font-black text-gray-900 uppercase tracking-widest mb-6">
                                            Existing
                                            Users - {{ role_information.role }}</h3>
                                        <div
                                            class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                                            <div>
                                                <p class="text-xs text-gray-400 font-bold">Displaying {{
                                                    getFilteredExistingUsers().length }} Records</p>
                                            </div>
                                            <div class="relative">
                                                <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
                                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                                </svg>
                                                <input type="text"
                                                    class="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-brandAccent focus:border-brandAccent w-full sm:w-64 transition-all"
                                                    placeholder="Search users..." [(ngModel)]="existingUserSearch">
                                            </div>
                                        </div>
                                        <div
                                            class="overflow-y-auto max-h-150 border border-gray-100 rounded-xl custom-scrollbar">
                                            <table class="w-full text-sm text-left">
                                                <thead
                                                    class="text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50/80 sticky top-0 border-b border-gray-100">
                                                    <tr style="background-color: rgb(255, 253, 253);">
                                                        <th class="px-4 py-3 cursor-pointer hover:text-gray-700 transition-colors"
                                                            (click)="existingUserSortReverse = !existingUserSortReverse">
                                                            <div class="flex items-center gap-1.5">
                                                                User
                                                                <svg class="w-3.5 h-3.5 transition-transform"
                                                                    [ngClass]="{'rotate-180': existingUserSortReverse}"
                                                                    fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fill-rule="evenodd"
                                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                        clip-rule="evenodd"></path>
                                                                </svg>
                                                            </div>
                                                        </th>
                                                        <th class="px-4 py-3 text-center w-24">Remove</th>
                                                    <tr
                                                        *ngIf="!isExistingUsersLoading && getFilteredExistingUsers().length === 0 && existingUserSearch">
                                                        <td colspan="2"
                                                            class="py-8 text-center text-gray-500 font-medium">
                                                            No users found
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody class="divide-y divide-gray-100/60">
                                                    <tr *ngIf="isExistingUsersLoading">
                                                        <td colspan="2"
                                                            class="py-6 text-center text-gray-400 font-medium">
                                                            Loading...</td>
                                                    </tr>
                                                    <tr *ngFor="let user_role of getFilteredExistingUsers()"
                                                        class="hover:bg-gray-50/50 transition-colors group">

                                                        <td class="px-4 py-3 max-w-[200px] sm:max-w-[280px]">
                                                            <div
                                                                class="flex flex-col gap-0.5 text-sm font-bold text-gray-900 break-all leading-snug">
                                                                <span>
                                                                    {{ (user_role.name.length > 20) ? (user_role.name |
                                                                    slice:0:20) : user_role.name }}
                                                                </span>
                                                                <span *ngIf="user_role.name.length > 20">
                                                                    {{ user_role.name | slice:20 }}
                                                                </span>
                                                            </div>
                                                        </td>

                                                        <td class="px-4 py-3 text-center w-24">
                                                            <button
                                                                class="w-8 h-8 inline-flex items-center justify-center rounded-lg border border-transparent text-red-400 hover:text-red-600 hover:bg-red-50 hover:border-red-100 transition-all"
                                                                title="Remove" (click)="removeUserRole(user_role)">
                                                                <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                    viewBox="0 0 24 24">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2"
                                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                                    </path>
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="!isExistingUsersLoading && userRoles.length === 0">
                                                        <td colspan="2"
                                                            class="py-8 text-center text-gray-400 font-bold">No
                                                            users assigned.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <!-- Available Users -->
                                    <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                                        <h3 class="text-sm font-black text-gray-900 uppercase tracking-widest mb-6">
                                            Available Users</h3>
                                        <div
                                            class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                                            <div>
                                                <p class="text-xs text-gray-400 font-bold">Displaying {{
                                                    getFilteredAvailableUsers().length }} Records</p>
                                            </div>
                                            <div class="relative">
                                                <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
                                                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                                </svg>
                                                <input type="text"
                                                    class="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-brandAccent focus:border-brandAccent w-full sm:w-64 transition-all"
                                                    placeholder="Search users..." [(ngModel)]="availableUserSearch">
                                            </div>
                                        </div>
                                        <div
                                            class="overflow-y-auto max-h-150 border border-gray-100 rounded-xl custom-scrollbar">
                                            <table class="w-full text-sm text-left">
                                                <thead
                                                    class="text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50/80 sticky top-0 border-b border-gray-100">
                                                    <tr style="background-color: rgb(255, 253, 253);">
                                                        <th class="px-4 py-3 cursor-pointer hover:text-gray-700 transition-colors"
                                                            (click)="availableUserSortReverse = !availableUserSortReverse">
                                                            <div class="flex items-center gap-1.5">
                                                                User
                                                                <svg class="w-3.5 h-3.5 transition-transform"
                                                                    [ngClass]="{'rotate-180': availableUserSortReverse}"
                                                                    fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fill-rule="evenodd"
                                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                        clip-rule="evenodd"></path>
                                                                </svg>
                                                            </div>
                                                        </th>
                                                        <th class="px-4 py-3 text-center w-24">Add</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="divide-y divide-gray-100/60">
                                                    <tr *ngIf="isAvailableUsersLoading">
                                                        <td colspan="2"
                                                            class="py-6 text-center text-gray-400 font-medium">
                                                            Loading...</td>
                                                    </tr>
                                                    <tr *ngFor="let available_user of getFilteredAvailableUsers()"
                                                        class="hover:bg-gray-50/50 transition-colors group">
                                                        <td class="px-4 py-3 font-bold text-gray-900">{{
                                                            available_user.name
                                                            }}</td>
                                                        <td class="px-4 py-3 text-center">
                                                            <button
                                                                class="w-8 h-8 inline-flex items-center justify-center rounded-lg border border-transparent text-brandAccent hover:text-brandPurple hover:bg-brandAccent/5 hover:border-brandAccent/10 transition-all"
                                                                title="Add"
                                                                (click)="assignAvailableUserToRole(available_user)">
                                                                <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                    viewBox="0 0 24 24">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        stroke-width="2" d="M12 4v16m8-8H4"></path>
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        *ngIf="!isAvailableUsersLoading && getFilteredAvailableUsers().length === 0 && availableUserSearch">
                                                        <td colspan="2"
                                                            class="py-8 text-center text-gray-500 font-medium">
                                                            No users found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <!-- ======== PERMISSIONS TAB ======== -->
                        <div *ngIf="isShowPermission">
                            <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                                    <div>
                                        <h3 class="text-sm font-black text-gray-900 uppercase tracking-widest mb-1">
                                            Entity
                                            Level Permissions</h3>
                                        <p class="text-xs text-gray-400 font-bold">Displaying {{
                                            getFilteredPermissions().length }} Records</p>
                                    </div>
                                    <div class="relative">
                                        <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
                                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                        </svg>
                                        <input type="text"
                                            class="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-brandAccent focus:border-brandAccent w-full sm:w-64 transition-all"
                                            placeholder="Search Permissions..." [(ngModel)]="permissionSearch">
                                    </div>
                                </div>
                                <div class="overflow-hidden border border-gray-100 rounded-xl">
                                    <div class="overflow-x-auto overflow-y-auto max-h-150 custom-scrollbar">
                                        <table class="min-w-full text-sm">
                                            <thead
                                                class="text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50/80 sticky top-0 border-b border-gray-100 z-10">
                                                <tr style="background-color: rgb(255, 253, 253);">
                                                    <th class="px-6 py-4 cursor-pointer hover:text-gray-700 transition-colors"
                                                        (click)="permissionSortReverse = !permissionSortReverse">
                                                        <div class="flex items-center gap-1.5">
                                                            Entity
                                                            <svg class="w-3.5 h-3.5 transition-transform"
                                                                [ngClass]="{'rotate-180': permissionSortReverse}"
                                                                fill="currentColor" viewBox="0 0 20 20">
                                                                <path fill-rule="evenodd"
                                                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                    clip-rule="evenodd"></path>
                                                            </svg>
                                                        </div>
                                                    </th>
                                                    <th class="px-4 py-4 text-center">Create</th>
                                                    <th class="px-4 py-4 text-center">View</th>
                                                    <th class="px-4 py-4 text-center">Update</th>
                                                    <th class="px-4 py-4 text-center">Delete</th>
                                                    <th class="px-4 py-4 text-center">Drops</th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-gray-100/60">
                                                <tr *ngIf="isLoadingPermission">
                                                    <td colspan="6"
                                                        class="px-6 py-8 text-center text-gray-400 font-medium">
                                                        Loading permissions...</td>
                                                </tr>
                                                <tr *ngFor="let permission of getFilteredPermissions(); let i = index"
                                                    class="hover:bg-gray-50/50 transition-colors"
                                                    [ngClass]="{'bg-brandAccent/[0.03]': permission.unique_id === currentIndex}">
                                                    <td class="px-6 py-4 font-bold text-gray-900">{{ permission.entity
                                                        }}
                                                    </td>
                                                    <td class="px-4 py-4 text-center">
                                                        <input type="checkbox"
                                                            class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                            [checked]="permission.create === 1"
                                                            (change)="permission.create = permission.create === 1 ? 0 : 1; addPermission(permission.create, permission, 'create', i)"
                                                            [disabled]="storeManager">
                                                    </td>
                                                    <td class="px-4 py-4 text-center">
                                                        <input type="checkbox"
                                                            class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                            [checked]="permission.view === 1"
                                                            (change)="permission.view = permission.view === 1 ? 0 : 1; addPermission(permission.view, permission, 'view', i)"
                                                            [disabled]="storeManager">
                                                    </td>
                                                    <td class="px-4 py-4 text-center">
                                                        <input type="checkbox"
                                                            class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                            [checked]="permission.update === 1"
                                                            (change)="permission.update = permission.update === 1 ? 0 : 1; addPermission(permission.update, permission, 'update', i)"
                                                            [disabled]="storeManager">
                                                    </td>
                                                    <td class="px-4 py-4 text-center">
                                                        <input type="checkbox"
                                                            class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                            [checked]="permission.delete === 1"
                                                            (change)="permission.delete = permission.delete === 1 ? 0 : 1; addPermission(permission.delete, permission, 'delete', i)"
                                                            [disabled]="storeManager">
                                                    </td>
                                                    <td class="px-4 py-4 text-center">
                                                        <input type="checkbox"
                                                            class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                            [checked]="permission.drop === 1"
                                                            (change)="permission.drop = permission.drop === 1 ? 0 : 1; addPermission(permission.drop, permission, 'drop', i)"
                                                            [disabled]="storeManager">
                                                    </td>
                                                </tr>
                                                <tr
                                                    *ngIf="!isLoadingPermission && getFilteredPermissions().length === 0 && permissionSearch">
                                                    <td colspan="6" class="py-8 text-center text-gray-500 font-medium">
                                                        No permissions found
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ======== ACCESS MODULES TAB ======== -->
                        <div *ngIf="isModules">
                            <div *ngIf="showNotificationAboutUserSession"
                                class="mb-6 bg-purple-50 border border-brandPurple/20 p-4 rounded-xl shadow-sm flex items-start gap-3">
                                <div class="text-brandPurple mt-0.5">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <h4 class="text-sm font-bold text-gray-900 mb-1">Session Update Required</h4>
                                    <p class="text-xs text-gray-600 leading-relaxed">Access changes will be reflected
                                        once
                                        the user logs out of active sessions.</p>
                                </div>
                            </div>

                            <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                                    <div>
                                        <h3 class="text-sm font-black text-gray-900 uppercase tracking-widest mb-1">
                                            Access
                                            Modules</h3>
                                        <p class="text-xs text-gray-400 font-bold">Displaying {{
                                            getFilteredModules().length
                                            }} Records</p>
                                    </div>
                                    <div class="relative">
                                        <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
                                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                        </svg>
                                        <input type="text"
                                            class="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-brandAccent focus:border-brandAccent w-full sm:w-64 transition-all"
                                            placeholder="Search modules..." [(ngModel)]="accessModuleSearch">
                                    </div>
                                </div>
                                <div
                                    class="overflow-x-auto overflow-y-auto max-h-150 custom-scrollbar border border-gray-100 rounded-xl">
                                    <table class="min-w-full text-sm">
                                        <thead
                                            class=" sticky top-0 z-10 text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50/80 border-b border-gray-100">
                                            <tr style="background-color: rgb(255, 253, 253);">
                                                <th class="px-6 py-4 cursor-pointer hover:text-gray-700 transition-colors"
                                                    (click)="modulesSortReverse = !modulesSortReverse">
                                                    <div class="flex items-center gap-1.5">
                                                        Module
                                                        <svg class="w-3.5 h-3.5 transition-transform"
                                                            [ngClass]="{'rotate-180': modulesSortReverse}"
                                                            fill="currentColor" viewBox="0 0 20 20">
                                                            <path fill-rule="evenodd"
                                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                clip-rule="evenodd"></path>
                                                        </svg>
                                                    </div>
                                                </th>
                                                <th class="px-6 py-4 text-center w-32">Access</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100/60">
                                            <tr *ngIf="isLoadingAccessModules">
                                                <td colspan="2" class="px-6 py-8 text-center text-gray-400 font-medium">
                                                    Loading modules...</td>
                                            </tr>
                                            <tr *ngFor="let module of getFilteredModules()"
                                                class="hover:bg-gray-50/50 transition-colors">
                                                <td class="px-6 py-4 font-bold text-gray-900">{{ module.name }}</td>
                                                <td class="px-6 py-4 text-center">
                                                    <input type="checkbox"
                                                        class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                        [checked]="module.access === 1"
                                                        (change)="module.access = module.access === 1 ? 0 : 1; updateModuleAccess(module)"
                                                        [disabled]="storeManager">
                                                </td>
                                            </tr>
                                            <tr
                                                *ngIf="!isLoadingAccessModules && getFilteredModules().length === 0 && accessModuleSearch">
                                                <td colspan="2" class="py-8 text-center text-gray-500 font-medium">
                                                    No modules found
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- ======== ACCESS WORKBENCH TAB ======== -->
                        <div *ngIf="isWorkbench">
                            <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                                    <div>
                                        <h3 class="text-sm font-black text-gray-900 uppercase tracking-widest mb-1">
                                            Access
                                            Workbench</h3>
                                        <p class="text-xs text-gray-400 font-bold">Displaying {{
                                            getFilteredWorkbenches().length }} Records</p>
                                    </div>
                                    <div class="relative">
                                        <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
                                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                        </svg>
                                        <input type="text"
                                            class="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-brandAccent focus:border-brandAccent w-full sm:w-64 transition-all"
                                            placeholder="Search workbench..." [(ngModel)]="accessWorkbenchSearch">
                                    </div>
                                </div>
                                <div
                                    class="overflow-x-auto overflow-y-auto max-h-150 custom-scrollbar border border-gray-100 rounded-xl">
                                    <table class="min-w-full text-sm">
                                        <thead
                                            class="text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50/80 border-b border-gray-100">
                                            <tr>
                                                <th class="px-6 py-4 cursor-pointer hover:text-gray-700 transition-colors"
                                                    (click)="workbenchSortReverse = !workbenchSortReverse">
                                                    <div class="flex items-center gap-1.5">
                                                        Workbench
                                                        <svg class="w-3.5 h-3.5 transition-transform"
                                                            [ngClass]="{'rotate-180': workbenchSortReverse}"
                                                            fill="currentColor" viewBox="0 0 20 20">
                                                            <path fill-rule="evenodd"
                                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                clip-rule="evenodd"></path>
                                                        </svg>
                                                    </div>
                                                </th>
                                                <th class="px-6 py-4 text-center w-32">Access</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100/60">
                                            <tr *ngIf="accessWorkbenchList.length === 0">
                                                <td colspan="2" class="px-6 py-8 text-center text-gray-400 font-medium">
                                                    Loading workbenches...</td>
                                            </tr>
                                            <tr *ngFor="let workbench of getFilteredWorkbenches()"
                                                class="hover:bg-gray-50/50 transition-colors">
                                                <td class="px-6 py-4 font-bold text-gray-900">{{ workbench.name }}</td>
                                                <td class="px-6 py-4 text-center">
                                                    <input type="checkbox"
                                                        class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                        [checked]="workbench.access === 1"
                                                        (change)="workbench.access = workbench.access === 1 ? 0 : 1; upsertWorkbenchAccess(workbench)"
                                                        [disabled]="storeManager">
                                                </td>
                                            </tr>
                                            <tr
                                                *ngIf="accessWorkbenchList.length > 0 && getFilteredWorkbenches().length === 0 && accessWorkbenchSearch">
                                                <td colspan="2" class="py-8 text-center text-gray-500 font-medium">
                                                    No workbenches found
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- ======== FEATURE PERMISSION TAB ======== -->
                        <div *ngIf="isFeatureModule">
                            <div class="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                                <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                                    <div>
                                        <h3 class="text-sm font-black text-gray-900 uppercase tracking-widest mb-1">
                                            Feature
                                            Permission</h3>
                                        <p class="text-xs text-gray-400 font-bold">Displaying {{
                                            getFilteredFeatures().length }} Records</p>
                                    </div>
                                    <div class="relative">
                                        <svg class="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2"
                                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                        </svg>
                                        <input type="text"
                                            class="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:ring-brandAccent focus:border-brandAccent w-full sm:w-64 transition-all"
                                            placeholder="Search features..." [(ngModel)]="featureSearch">
                                    </div>
                                </div>
                                <div
                                    class="overflow-x-auto overflow-y-auto max-h-150 custom-scrollbar border border-gray-100 rounded-xl">
                                    <table class="min-w-full text-sm">
                                        <thead
                                            class="sticky top-0 z-10 text-xs font-bold text-gray-400 uppercase tracking-widest bg-gray-50/80 border-b border-gray-100">
                                            <tr style="background-color: rgb(255, 253, 253);">
                                                <th class="px-6 py-4 cursor-pointer hover:text-gray-700 transition-colors"
                                                    (click)="featureSortReverse = !featureSortReverse">
                                                    <div class="flex items-center gap-1.5">
                                                        Feature
                                                        <svg class="w-3.5 h-3.5 transition-transform"
                                                            [ngClass]="{'rotate-180': featureSortReverse}"
                                                            fill="currentColor" viewBox="0 0 20 20">
                                                            <path fill-rule="evenodd"
                                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                clip-rule="evenodd"></path>
                                                        </svg>
                                                    </div>
                                                </th>
                                                <th class="px-6 py-4 text-center w-32">Access</th>
                                                <th class="px-6 py-4 text-center w-48">Require Password</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-100/60">
                                            <tr *ngIf="isLoadingFeatureList">
                                                <td colspan="3" class="px-6 py-8 text-center text-gray-400 font-medium">
                                                    Loading features...</td>
                                            </tr>
                                            <tr *ngFor="let feature of getFilteredFeatures()"
                                                class="hover:bg-gray-50/50 transition-colors">
                                                <td class="px-6 py-4 font-bold text-gray-900">{{ feature.feature }}</td>
                                                <td class="px-6 py-4 text-center">
                                                    <input type="checkbox"
                                                        class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                        [checked]="feature.access === 1"
                                                        (change)="feature.access = feature.access === 1 ? 0 : 1; upsertFeature(feature)"
                                                        [disabled]="storeManager">
                                                </td>
                                                <td class="px-6 py-4 text-center">
                                                    <input type="checkbox"
                                                        class="w-4 h-4 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                                        [checked]="feature.allow_featured_password === 1"
                                                        (change)="feature.allow_featured_password = feature.allow_featured_password === 1 ? 0 : 1; upsertFeature(feature)"
                                                        [disabled]="!feature.access || storeManager || (feature.feature_code == 'CDash-CORP' || feature.feature_code == 'CDash-MGR' || feature.feature_code == 'CDash-ASC')">
                                                </td>
                                            </tr>
                                            <tr
                                                *ngIf="!isLoadingFeatureList && getFilteredFeatures().length === 0 && featureSearch">
                                                <td colspan="3" class="py-8 text-center text-gray-500 font-medium">
                                                    No features found
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ================================================================ -->
            <!-- DELETE ROLE MODAL -->
            <!-- ================================================================ -->
            <div *ngIf="enableDeleteUser"
                class="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                <div
                    class="bg-white w-full max-w-md rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                    <!-- Confirm State -->
                    <div *ngIf="!hasRoleDeleted && !roleDeleteErrorMessage" class="p-8 text-center">
                        <div
                            class="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                </path>
                            </svg>
                        </div>
                        <h3 class="text-xl font-black text-gray-900 mb-2">Delete Role</h3>
                        <p class="text-gray-500 mb-6 text-sm">Are you sure you want to delete <span
                                class="font-bold text-gray-800">{{ roleInfo?.role }}</span>? This action cannot be
                            undone.
                        </p>
                        <div class="flex justify-center gap-3">
                            <button
                                class="flex-1 px-4 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                                (click)="cancelDeleteRole()">Cancel</button>
                            <button
                                class="flex-1 px-4 py-2.5 bg-red-500 hover:bg-red-600 text-white rounded-xl shadow-sm text-sm font-bold transition-all shadow-red-500/20"
                                (click)="deleteRole(roleInfo)">Yes, Delete</button>
                        </div>
                    </div>
                    <!-- Success State -->
                    <div *ngIf="hasRoleDeleted && !roleDeleteErrorMessage" class="p-8 text-center">
                        <div
                            class="w-16 h-16 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7">
                                </path>
                            </svg>
                        </div>
                        <h3 class="text-xl font-black text-gray-900 mb-2">Deleted!</h3>
                        <p class="text-gray-500 text-sm">Role has been successfully deleted.</p>
                    </div>
                    <!-- Error State -->
                    <div *ngIf="!hasRoleDeleted && roleDeleteErrorMessage" class="p-8 text-center">
                        <div
                            class="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <h3 class="text-xl font-black text-gray-900 mb-2">Error</h3>
                        <p class="text-gray-500 mb-6 text-sm">{{ roleDeleteErrorMessage }}</p>
                        <button
                            class="w-full px-4 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                            (click)="cancelDeleteRole()">Close</button>
                    </div>
                </div>
            </div>

            <!-- ================================================================ -->
            <!-- CREATE ROLE MODAL -->
            <!-- ================================================================ -->
            <div *ngIf="isCreateRole"
                class="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                <div
                    class="bg-white w-full max-w-lg rounded-2xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh] animate-in fade-in zoom-in-95 duration-200">
                    <div
                        class="px-8 py-6 border-b border-gray-100 bg-white flex justify-between items-center sticky top-0 z-10">
                        <h2 class="text-xl font-black text-gray-900 tracking-tight">Create Role</h2>
                        <button
                            class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all"
                            (click)="closeForm()">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <!-- Form -->
                    <div *ngIf="!isSaveSuccess" class="p-5 overflow-y-auto">
                        <div class="flex flex-col gap-5">
                            <!-- Role Name -->
                            <div>
                                <!-- Role Name -->
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Role Name
                                    <span
                                        [style.color]="role.role?.trim().length >= 2 && role.role?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <input type="text" [(ngModel)]="role.role" maxlength="40"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all"
                                    [class.border-green-500]="role.role?.trim().length >= 2 && role.role?.trim().length <= 40"
                                    [class.border-red-500]="role.role?.trim().length > 0 && (role.role?.trim().length < 2 || role.role?.trim().length > 40)"
                                    placeholder="Enter Role Name">
                                <p *ngIf="role.role && role.role.trim().length > 0 && (role.role.trim().length < 2 || role.role.trim().length > 40)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 40 chars
                                </p>
                            </div>

                            <!-- Role Code -->
                            <div>
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Role Code
                                    <span
                                        [style.color]="role.code?.trim().length >= 2 && role.code?.trim().length <= 10 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <input type="text" [(ngModel)]="role.code" maxlength="10"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all"
                                    [class.border-green-500]="role.code?.trim().length >= 2 && role.code?.trim().length <= 10"
                                    [class.border-red-500]="role.code?.trim().length > 0 && (role.code?.trim().length < 2 || role.code?.trim().length > 10)"
                                    [class.border-gray-200]="!role.code || (role.code?.trim().length >= 2 && role.code?.trim().length <= 10)"
                                    placeholder="Enter Role Code">
                                <p *ngIf="role.code?.trim().length > 0 && (role.code?.trim().length < 2 || role.code?.trim().length > 10)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 10 chars
                                </p>
                            </div>
                            <!-- Details -->
                            <div class="mt-4">
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Details
                                    <span
                                        [style.color]="role.details?.trim().length >= 2 && role.details?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <textarea [(ngModel)]="role.details" rows="3" maxlength="40"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all resize-none"
                                    [class.border-green-500]="role.details?.trim().length >= 2 && role.details?.trim().length <= 40"
                                    [class.border-red-500]="role.details?.trim().length > 0 && (role.details?.trim().length < 2 || role.details?.trim().length > 40)"
                                    [class.border-gray-200]="!role.details || role.details?.trim().length === 0"
                                    placeholder="Enter Role Details"></textarea>
                                <p *ngIf="role.details && role.details.trim().length > 0 && (role.details.trim().length < 2 || role.details.trim().length > 40)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 40 chars
                                </p>
                            </div>
                            <!-- Is LSA Checkbox -->
                            <div
                                class="flex items-center gap-3 mt-2 bg-gray-50/50 p-4 rounded-xl border border-gray-100">
                                <input type="checkbox" [(ngModel)]="role.is_lsa" [ngModelOptions]="{standalone: true}"
                                    class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer"
                                    [value]="1" id="lsa_check">
                                <label for="lsa_check"
                                    class="text-sm text-gray-700 font-bold cursor-pointer select-none">
                                    Can Access By Location Security Administrator?
                                </label>
                            </div>
                        </div>

                        <div *ngIf="message" class="mt-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-r-xl">
                            <p class="text-red-700 text-sm font-bold">{{ message }}</p>
                        </div>
                    </div>

                    <!-- Success -->
                    <div *ngIf="isSaveSuccess" class="p-10 text-center">
                        <div
                            class="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7">
                                </path>
                            </svg>
                        </div>
                        <h3 class="text-2xl font-black text-gray-900 mb-2">Role Created!</h3>
                        <p class="text-gray-500 mb-8 text-sm">The new role has been successfully added.</p>
                        <div class="flex justify-center gap-3">
                            <button
                                class="px-6 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                                (click)="closeForm()">Close</button>
                            <button
                                class="px-6 py-2.5 bg-brandAccent hover:bg-brandPurple text-white rounded-xl shadow-sm shadow-brandAccent/20 text-sm font-bold transition-all"
                                (click)="createAnotherForm()">Create Another</button>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div *ngIf="!isSaveSuccess"
                        class="px-8 py-5 border-t border-gray-100 bg-gray-50/50 flex justify-end gap-3 sticky bottom-0">
                        <button
                            class="px-5 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                            (click)="closeForm()" [disabled]="isSaving">Cancel</button>
                        <button
                            class="px-5 py-2.5 bg-brandAccent hover:bg-brandPurple text-white rounded-xl shadow-sm shadow-brandAccent/20 text-sm font-bold transition-all disabled:opacity-50"
                            [disabled]="isFormInvalid() || isSaving" (click)="save(role)">
                            {{ isSaving ? 'Saving...' : saveBtnText }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- ================================================================ -->
            <!-- CLONE ROLE MODAL -->
            <!-- ================================================================ -->
            <div *ngIf="isCloneRole"
                class="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                <div
                    class="bg-white w-full max-w-lg rounded-2xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh] animate-in fade-in zoom-in-95 duration-200">
                    <div
                        class="px-8 py-6 border-b border-gray-100 bg-white flex justify-between items-center sticky top-0 z-10">
                        <h2 class="text-xl font-black text-gray-900 tracking-tight">Clone Role</h2>
                        <button
                            class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all"
                            (click)="closeCloneForm()">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <div *ngIf="!isCloneSuccess" class="p-5 overflow-y-auto">
                        <div class="bg-blue-50/50 border border-blue-100 rounded-xl p-4 mb-6 flex gap-3">
                            <svg class="w-5 h-5 text-blue-500 shrink-0 mt-0.5" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <p class="text-xs text-blue-800 leading-relaxed font-medium">Cloning a role creates an exact
                                copy of its summary and permissions. Assigned users will also be carried over to the new
                                role.</p>
                        </div>

                        <div class="flex flex-col gap-5">
                            <!-- Role Name -->
                            <div>
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Role Name
                                    <span
                                        [style.color]="role.role?.length >= 2 && role.role?.length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <input type="text" [(ngModel)]="role.role"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all"
                                    [class.border-red-500]="role.role?.length > 0 && (role.role?.length < 2 || role.role?.length > 40)"
                                    [class.border-green-500]="role.role?.length >= 2 && role.role?.length <= 40"
                                    [class.border-gray-200]="!role.role" placeholder="Enter Role Name">
                                <p *ngIf="role.role?.length > 0 && (role.role?.length < 2 || role.role?.length > 40)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 40 chars
                                </p>

                            </div>

                            <!-- Role Code -->
                            <div>
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Role Code
                                    <span
                                        [style.color]="role.code?.length >= 2 && role.code?.length <= 10 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <input type="text" [(ngModel)]="role.code"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all"
                                    [class.border-red-500]="role.code?.length > 0 && (role.code?.length < 2 || role.code?.length > 10)"
                                    [class.border-green-500]="role.code?.length >= 2 && role.code?.length <= 10"
                                    [class.border-gray-200]="!role.code" placeholder="Enter Role Code">
                                <p *ngIf="role.code?.length > 0 && (role.code?.length < 2 || role.code?.length > 10)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 10 chars
                                </p>

                            </div>

                            <!-- Details -->
                            <div>
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Details
                                    <span
                                        [style.color]="role.details?.length >= 2 && role.details?.length <= 10 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <textarea [(ngModel)]="role.details" rows="3"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all resize-none"
                                    [class.border-red-500]="role.details?.length > 0 && (role.details?.length < 2 || role.details?.length > 10)"
                                    [class.border-green-500]="role.details?.length >= 2 && role.details?.length <= 10"
                                    [class.border-gray-200]="!role.details" placeholder="Enter Role Details"></textarea>
                                <p *ngIf="role.details?.length > 0 && (role.details?.length < 2 || role.details?.length > 10)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 10 chars
                                </p>

                            </div>

                            <!-- Is LSA Checkbox -->
                            <div
                                class="flex items-center gap-3 mt-2 bg-gray-50/50 p-4 rounded-xl border border-gray-100">
                                <input type="checkbox" [(ngModel)]="role.is_lsa" [ngModelOptions]="{standalone: true}"
                                    class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer"
                                    [value]="1" id="clone_lsa_check">
                                <label for="clone_lsa_check"
                                    class="text-sm text-gray-700 font-bold cursor-pointer select-none">
                                    Can Access By Location Security Administrator?
                                </label>
                            </div>
                        </div>
                        <div *ngIf="message" class="mt-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-r-xl">
                            <p class="text-red-700 text-sm font-bold">{{ message }}</p>
                        </div>
                    </div>

                    <div *ngIf="isCloneSuccess" class="p-10 text-center">
                        <div
                            class="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7">
                                </path>
                            </svg>
                        </div>
                        <h3 class="text-2xl font-black text-gray-900 mb-2">Role Cloned!</h3>
                        <p class="text-gray-500 mb-8 text-sm">The role was successfully cloned.</p>
                        <div class="flex justify-center gap-3">
                            <button
                                class="px-6 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                                (click)="closeCloneForm()">Close</button>
                        </div>
                    </div>

                    <div *ngIf="!isCloneSuccess"
                        class="px-8 py-5 border-t border-gray-100 bg-gray-50/50 flex justify-end gap-3 sticky bottom-0">
                        <button
                            class="px-5 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                            (click)="closeCloneForm()">Cancel</button>
                        <button
                            class="px-5 py-2.5 bg-brandAccent hover:bg-brandPurple text-white rounded-xl shadow-sm shadow-brandAccent/20 text-sm font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                            [ngClass]="{'bg-red-500 hover:bg-red-600 shadow-red-500/20': cloneBtnError}"
                            [disabled]="isFormInvalid() || !isProcessed" (click)="clone(role)">{{ cloneBtnTxt
                            }}</button>
                    </div>
                </div>
            </div>

            <!-- ================================================================ -->
            <!-- UPDATE ROLE MODAL -->
            <!-- Update Role Modal -->
            <div *ngIf="isUpdateRole"
                class="fixed inset-0 z-[150] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                <div
                    class="bg-white w-full max-w-lg rounded-2xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh] animate-in fade-in zoom-in-95 duration-200">
                    <div
                        class="px-8 py-6 border-b border-gray-100 bg-white flex justify-between items-center sticky top-0 z-10">
                        <h2 class="text-xl font-black text-gray-900 tracking-tight">Update Role</h2>
                        <button
                            class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all"
                            (click)="closeUpdateForm()">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <div *ngIf="!isUpdateSuccess" class="p-5 overflow-y-auto">
                        <div class="flex flex-col gap-5">
                            <!-- Role Name -->
                            <div>
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Role Name
                                    <span
                                        [style.color]="roleDetails.role?.trim().length >= 2 && roleDetails.role?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <input type="text" [(ngModel)]="roleDetails.role" maxlength="40"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all"
                                    [class.border-green-500]="roleDetails.role?.trim().length >= 2 && roleDetails.role?.trim().length <= 40"
                                    [class.border-red-500]="roleDetails.role?.trim().length > 0 && (roleDetails.role?.trim().length < 2 || roleDetails.role?.trim().length > 40)"
                                    [class.border-gray-200]="!roleDetails.role || (roleDetails.role?.trim().length >= 2 && roleDetails.role?.trim().length <= 40)"
                                    placeholder="Enter Role Name">
                                <p *ngIf="roleDetails.role?.trim().length > 0 && (roleDetails.role?.trim().length < 2 || roleDetails.role?.trim().length > 40)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 40 chars
                                </p>
                            </div>

                            <div class="mt-4">
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Role Code
                                    <span
                                        [style.color]="roleDetails.code?.trim().length >= 2 && roleDetails.code?.trim().length <= 10 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <input type="text" [(ngModel)]="roleDetails.code" maxlength="10"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all"
                                    [class.border-green-500]="roleDetails.code?.trim().length >= 2 && roleDetails.code?.trim().length <= 10"
                                    [class.border-red-500]="roleDetails.code?.trim().length > 0 && (roleDetails.code?.trim().length < 2 || roleDetails.code?.trim().length > 10)"
                                    [class.border-gray-200]="!roleDetails.code || (roleDetails.code?.trim().length >= 2 && roleDetails.code?.trim().length <= 10)"
                                    placeholder="Enter Role Code">
                                <p *ngIf="roleDetails.code?.trim().length > 0 && (roleDetails.code?.trim().length < 2 || roleDetails.code?.trim().length > 10)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 10 chars
                                </p>
                            </div>

                            <div class="mt-4">
                                <label class="block text-xs font-black text-gray-900 uppercase tracking-widest mb-2">
                                    Details
                                    <span
                                        [style.color]="roleDetails.details?.trim().length >= 2 && roleDetails.details?.trim().length <= 40 ? '#10b981' : '#ef4444'">*</span>
                                </label>
                                <textarea [(ngModel)]="roleDetails.details" rows="3" maxlength="40"
                                    class="w-full px-4 py-3 bg-gray-50 border rounded-xl text-sm focus:bg-white focus:ring-2 focus:ring-brandAccent/20 focus:border-brandAccent transition-all resize-none"
                                    [class.border-green-500]="roleDetails.details?.trim().length >= 2 && roleDetails.details?.trim().length <= 40"
                                    [class.border-red-500]="roleDetails.details?.trim().length > 0 && (roleDetails.details?.trim().length < 2 || roleDetails.details?.trim().length > 40)"
                                    [class.border-gray-200]="!roleDetails.details || (roleDetails.details?.trim().length >= 2 && roleDetails.details?.trim().length <= 40)"
                                    placeholder="Enter Role Details"></textarea>
                                <p *ngIf="roleDetails.details?.trim().length > 0 && (roleDetails.details?.trim().length < 2 || roleDetails.details?.trim().length > 40)"
                                    class="text-[10px] text-red-500 font-bold mt-1">
                                    Min 2 & Max 40 chars
                                </p>
                            </div>
                            <!-- Is LSA Checkbox -->
                            <div
                                class="flex items-center gap-3 mt-2 bg-gray-50/50 p-4 rounded-xl border border-gray-100">
                                <input type="checkbox" [(ngModel)]="roleDetails.is_lsa"
                                    [ngModelOptions]="{standalone: true}"
                                    class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors cursor-pointer disabled:opacity-50"
                                    [value]="1" id="update_lsa_check" [disabled]="roleDetails?.id == 83">
                                <label for="update_lsa_check"
                                    class="text-sm text-gray-700 font-bold cursor-pointer select-none"
                                    [ngClass]="{'opacity-50': roleDetails?.id == 83}">
                                    Can Access By Location Security Administrator?
                                </label>
                            </div>
                        </div>
                        <div *ngIf="updateUserMessage"
                            class="mt-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-r-xl">
                            <p class="text-red-700 text-sm font-bold">{{ updateUserMessage }}</p>
                        </div>
                    </div>

                    <div *ngIf="isUpdateSuccess" class="p-10 text-center">
                        <div
                            class="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7">
                                </path>
                            </svg>
                        </div>
                        <h3 class="text-2xl font-black text-gray-900 mb-2">Role Updated!</h3>
                        <p class="text-gray-500 mb-8 text-sm">The role details have been successfully updated.</p>
                        <div class="flex justify-center gap-3">
                            <button
                                class="px-6 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                                (click)="closeUpdateForm()">Close</button>
                        </div>
                    </div>

                    <div *ngIf="!isUpdateSuccess"
                        class="px-8 py-5 border-t border-gray-100 bg-gray-50/50 flex justify-end gap-3 sticky bottom-0">
                        <button
                            class="px-5 py-2.5 border border-gray-200 bg-white text-gray-700 rounded-xl shadow-sm text-sm font-bold hover:bg-gray-50 transition-all"
                            (click)="closeUpdateForm()" [disabled]="isUpdating">Cancel</button>
                        <button
                            class="px-5 py-2.5 bg-brandAccent hover:bg-brandPurple text-white rounded-xl shadow-sm shadow-brandAccent/20 text-sm font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                            [ngClass]="{'bg-red-500 hover:bg-red-600 shadow-red-500/20': updateBtnError}"
                            [disabled]="isUpdateFormInvalid() || isUpdating" (click)="updateRole(roleDetails)">
                            {{ isUpdating ? 'Updating...' : updateBtnText }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- ================================================================ -->
            <!-- COLUMN SETTINGS SLIDE-OVER -->
            <!-- ================================================================ -->
            <div class="fixed inset-0 z-[160] overflow-hidden transition-all duration-300 ease-in-out pointer-events-none"
[ngClass]="isColumnSettingsVisible ? 'visible' : 'invisible'" 
     *ngIf="getTotalFilteredCount() > 0 || search">
                <!-- Backdrop -->
                <div class="absolute inset-0 bg-black/20 backdrop-blur-sm transition-opacity duration-300 ease-in-out pointer-events-auto"
                    [ngClass]="isColumnSettingsVisible ? 'opacity-100' : 'opacity-0'"
                    (click)="isColumnSettingsVisible = false"></div>

                <!-- Slide-over panel -->
                <div class="absolute inset-y-0 right-0 w-80 bg-white shadow-2xl transition-transform duration-300 ease-in-out pointer-events-auto flex flex-col"
                    [ngClass]="isColumnSettingsVisible ? 'translate-x-0' : 'translate-x-full'">
                    <div class="px-6 py-5 border-b border-gray-100 bg-white flex justify-between items-center">
                        <h2 class="text-sm font-black text-gray-900 uppercase tracking-widest">Column Settings</h2>
                        <button
                            class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all"
                            (click)="isColumnSettingsVisible = false">
                            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="p-6 flex flex-col gap-5 overflow-y-auto bg-gray-50/30 flex-1">
                        <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer group">
                            <input type="checkbox" [(ngModel)]="columnVisibility['role']"
                                [ngModelOptions]="{standalone: true}"
                                class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors">
                            <span class="font-bold group-hover:text-brandPurple transition-colors">Role</span>
                        </label>
                        <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer group">
                            <input type="checkbox" [(ngModel)]="columnVisibility['code']"
                                [ngModelOptions]="{standalone: true}"
                                class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors">
                            <span class="font-bold group-hover:text-brandPurple transition-colors">Code</span>
                        </label>
                        <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer group">
                            <input type="checkbox" [(ngModel)]="columnVisibility['details']"
                                [ngModelOptions]="{standalone: true}"
                                class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors">
                            <span class="font-bold group-hover:text-brandPurple transition-colors">Details</span>
                        </label>
                        <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer group">
                            <input type="checkbox" [(ngModel)]="columnVisibility['view']"
                                [ngModelOptions]="{standalone: true}"
                                class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors">
                            <span class="font-bold group-hover:text-brandPurple transition-colors">View</span>
                        </label>
                        <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer group">
                            <input type="checkbox" [(ngModel)]="columnVisibility['clone']"
                                [ngModelOptions]="{standalone: true}"
                                class="w-5 h-5 rounded border-gray-300 text-brandAccent focus:ring-brandAccent transition-colors">
                            <span class="font-bold group-hover:text-brandPurple transition-colors">Clone</span>
                        </label>
                    </div>
                </div>
            </div>

        </div>
        <footer class="login-footer">
            <span *ngIf="copyrightDetails">
                &copy; {{ copyrightDetails.from_year }} - {{ copyrightDetails.to_year }},
                Retail Calculus or its affiliates. All rights reserved.
            </span>
            <span *ngIf="!copyrightDetails">
                &copy; 2016 - 2026, Retail Calculus or its affiliates. All rights reserved.
            </span>

            <div class="footer-links">
                <a href="javascript:void(0)">Privacy Policy</a>
                <a href="javascript:void(0)">Terms of Use</a>
                <span class="version" *ngIf="copyrightDetails?.app_version">
                    Version {{ copyrightDetails.app_version }}
                </span>
            </div>
        </footer>
    </div>
</div>